import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutRoutingModule } from './layout-routing.module';
import { AngularMaterialModule } from '../angular-material.module';
import { ChatModule } from '../chat/chat.module';
import { SharedModule } from '../shared/shared.module';
import { TopnavbarComponent } from './topnavbar/topnavbar.component';
import { FooternavbarComponent } from './footernavbar/footernavbar.component';
import { ChatBotComponent } from '../chat-bot/chat-bot.component';

@NgModule({
  declarations: [
    TopnavbarComponent,
    FooternavbarComponent,
    ChatBotComponent
  ],
  exports:[
    TopnavbarComponent,
    FooternavbarComponent
  ],
  imports: [
    LayoutRoutingModule,
    AngularMaterialModule,
    ChatModule,
    SharedModule
  ]
})
export class LayoutModule { }
